import * as React from 'react';
import api from 'core/api';
import * as Sentry from '@sentry/react';
import { formatAuditLogsForDisplay } from './utils';
import { AuditLogResponseItem, PostRegEditLogDisplay } from './types';
import { useShowOrganization } from 'hooks/GraphQL';

interface Props {
    formResultId: number;
    orgId: number;
    isOpen: boolean;
}
   
export const fetchAuditLogs = async (formResultId: number): Promise<AuditLogResponseItem[]> => {
    try {
        const response = await api.get(`/form_results/${formResultId}/audit_logs`);
        if (!Array.isArray(response.data)) {
            throw new Error('Invalid response data');
        }
        return response.data as AuditLogResponseItem[];
    } catch (e) {
        Sentry.captureException(e);
        return [];
    }
}

const usePostRegEditLogs = ({ formResultId, isOpen, orgId }: Props) => {
    const [editLogs, setEditLogs] = React.useState<PostRegEditLogDisplay[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [data] = useShowOrganization(orgId);
    const timezoneIana = data?.showOrganization?.timezoneIana as unknown as string;

    const loadAuditLogsData = async (id) => {
        try {
            // get the logs
            const data = await fetchAuditLogs(id);
            if (!data || data.length === 0) {
                setLoading(false);
                setEditLogs([]);
                return;
            }
            setEditLogs(formatAuditLogsForDisplay(data));
        } catch (e) {
            Sentry.captureException(e);
            setEditLogs([]);
        } finally {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        formResultId && isOpen && loadAuditLogsData(formResultId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formResultId, isOpen]);

    return {
        editLogs,
        loading,
        orgTimezoneIana: timezoneIana,
    };
}
export default usePostRegEditLogs;
